import React from 'react';
import { StyleSheet, Text, View, TouchableOpacity, Animated } from 'react-native';
// import Icon from 'react-native-ionicons';
import { Ionicons as Icon } from '@expo/vector-icons';
import Colors from '../../constants/Colors';
import FontStyles from '../../constants/FontStyle';

let intervalTime = null;

const CartCountButton = ({
    product,
    stockCount,

    orderQty,
    setOrderQty,

    ...props
}) => {

    // const [pressAction, setPressAction] = React.useState(new Animated.Value(0))
    const pressAction = React.useRef(new Animated.Value(0)).current
    const [quantity, setQuantity] = React.useState(0);

    const [minState, setMinState] = React.useState(false);
    const [maxState, setMaxState] = React.useState(false);

    const changeOrderQty = (value, type, isCase) => {

        if (isCase) {
            value = parseInt(value) || 0
            value = value * product?.case_count || 1
        }

        switch (type) {
            case 'increment':
                // increment
                value = orderQty + value;
                if (stockCount && value > stockCount) {
                    setMinState(false)
                    setMaxState(true);
                    return;
                }
                setMinState(false);
                setMaxState(false);
                setOrderQty(value);
                break;
            case 'decrement':
                // decrement
                value = orderQty - value;
                if (value < product?.pricetag?.mpu) {
                    if (!isCase) { setMinState(true) }
                    setMaxState(false);
                    return;
                }
                setMinState(false);
                setMaxState(false);
                setOrderQty(prev => {
                    return value
                });
                break;
            default:
                // do nothing
                break;
        }
    }

    const getLowerUpperUnitText = () => {
        return (parseInt(orderQty / product?.case_count) > 0
            ? `${parseInt(orderQty / product?.case_count)} ${product?.tags?.HIGHER_UNIT?.value}${parseInt(orderQty / product?.case_count) > 1 ? 's' : ''}${(orderQty % product?.case_count) ? ' ' : ''}`
            : ``) + (orderQty % product?.case_count > 0
            ? `${orderQty % product?.case_count} ${product?.tags?.LOWER_UNIT?.value}${orderQty % product?.case_count > 1 ? 's' : ''}`
            : ``)
    }

    const pressIn = (value, type, isCase) => {
        let val = value
        intervalTime = setInterval(() => {
            val += value
            changeOrderQty(val, type, isCase)
        }, 100)
    }

    const pressOut = () => {
        clearInterval(intervalTime)
    }

    React.useEffect(() => {
        pressAction.addListener(x => setQuantity(x.value))

        return () => {
            pressAction.removeAllListeners()
        }
    }, [])

    return <View style={styles.main}>
        <Text style={styles.selectionHeader}>Quantity</Text>
        <View style={styles.mainCounterWrapper}>

            {/* cases and units combined */}
            <View style={styles.counterWrapper}>
                <TouchableOpacity
                    disabled={minState}
                    style={[
                        styles.counterBtn,
                        minState ? styles.counterBtnInactive : null
                    ]}
                    onPressIn={() => changeOrderQty(product?.pricetag?.mpu, 'decrement', false)}
                    onLongPress={() => pressIn(product?.pricetag?.mpu, 'decrement', false)}
                    onPressOut={pressOut}
                    delayLongPress={200}
                >
                    <Icon name="md-remove" size={24} color='#FFFFFF' />
                </TouchableOpacity>

                <Text style={styles.counterInput}>{getLowerUpperUnitText()}</Text>

                <TouchableOpacity
                    disabled={maxState}
                    style={[
                        styles.counterBtn,
                        maxState ? styles.counterBtnInactive : null
                    ]}
                    onPressIn={() => changeOrderQty(product?.pricetag?.mpu, 'increment', false)}
                    onLongPress={() => pressIn(product?.pricetag?.mpu, 'increment', false)}
                    onPressOut={pressOut}
                    delayLongPress={200}
                >
                    <Icon name="md-add" size={24} color='#FFFFFF' />
                </TouchableOpacity>
            </View>
        </View>
    </View>
}

export default CartCountButton;


const styles = StyleSheet.create({
    main: {
        flex: 1,
        alignSelf: 'stretch',
    },
    selectionHeader: {
        ...FontStyles.normal,
        ...FontStyles.gray,
        ...FontStyles.size14,
        ...FontStyles.lh18,
        textTransform: 'capitalize',
        marginHorizontal: 16,
        marginVertical: 10,
    },
    mainCounterWrapper: {
        flex: 1,
        flexDirection: 'row',
        paddingHorizontal: 11,
    },
    counterWrapper: {
        flex: 1,
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',

        paddingVertical: 4,
        paddingHorizontal: 6,
        marginHorizontal: 5,

        borderColor: '#3B54EC0D',
        backgroundColor: '#3B54EC1A',
        borderWidth: 1,
        borderStyle: 'solid',
        borderRadius: 6,
    },
    counterBtn: {
        width: 34,
        height: 34,
        borderRadius: 17,
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: Colors.tintColor,
        color: '#FFFFFF'
    },
    counterBtnInactive: {
        backgroundColor: Colors.tintColor + '6A',
    },
    counterInput: {
        ...FontStyles.size14,
        ...FontStyles.lh22,
        ...FontStyles.semibold,
        ...FontStyles.dark,
        paddingVertical: 0,
        marginHorizontal: 20,
        textAlign: "center"
    },
})
